import React from "react";
import logo from "../images/isuzulogowhite.png"; // your logo
import { motion } from "framer-motion";

const Loader = () => {
  return (
    <div className="fixed inset-0 flex flex-col items-center justify-center bg-black z-[9999] overflow-hidden">
      
      {/* Rotating Logo */}
      <motion.img
        src={logo}
        alt="Isuzu Logo"
        className="w-32 md:w-40 mb-8"
        initial={{ scale: 0.7, rotate: 0, opacity: 0 }}
        animate={{ scale: 1, rotate: 360, opacity: 1 }}
        transition={{
          duration: 2,
          repeat: Infinity,
          ease: "easeInOut",
        }}
      />

      {/* Glowing Pulse Bars */}
      <div className="flex space-x-2">
        {[1, 2, 3, 4, 5].map((i) => (
          <motion.div
            key={i}
            className="w-3 h-8 bg-[#D71920] rounded-full"
            initial={{ scaleY: 0.3, opacity: 0.5 }}
            animate={{ scaleY: [0.3, 1, 0.3], opacity: [0.5, 1, 0.5] }}
            transition={{
              duration: 1.2,
              repeat: Infinity,
              repeatType: "loop",
              delay: i * 0.2,
            }}
          />
        ))}
      </div>

      {/* Fading Tagline */}
      {/* <motion.p
        className="text-white mt-6 text-sm md:text-base tracking-widest uppercase"
        initial={{ opacity: 0 }}
        animate={{ opacity: [0, 1, 0] }}
        transition={{ duration: 2, repeat: Infinity }}
      >
        Loading Isuzu Experience...
      </motion.p> */}

      {/* Optional subtle moving vehicle silhouette (decorative) */}
      <motion.div
        className="absolute bottom-10 w-40 h-1 bg-white rounded-full opacity-20"
        animate={{ x: ["-50%", "50%", "-50%"] }}
        transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
      />
    </div>
  );
};

export default Loader;
